const SIGIL_GLYPHS = [
  "ᚠ",
  "ᚢ",
  "ᚦ",
  "ᚨ",
  "ᚱ",
  "ᚲ",
  "ᚷ",
  "ᚹ",
  "ᚺ",
  "ᚾ",
  "ᛁ",
  "ᛃ",
  "ᛇ",
  "ᛈ",
  "ᛉ",
  "ᛋ",
  "ᛏ",
  "ᛒ",
  "ᛖ",
  "ᛗ",
  "ᛚ",
  "ᛝ",
  "ᛞ",
  "ᛟ",
  "ᚩ",
  "ᚪ",
  "ᚫ",
  "ᚣ",
  "ᚳ",
  "ᚸ",
  "ᚻ",
  "ᚼ",
  "ᚽ",
  "ᚿ",
  "ᛀ",
  "ᛂ"
];

const BASE32 = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";

function normalizePart(value) {
  return (value ?? "").trim().normalize("NFKC").toLowerCase();
}

function fnv1a(input) {
  let hash = 0x811c9dc5;
  for (let i = 0; i < input.length; i += 1) {
    hash ^= input.charCodeAt(i);
    hash = (hash * 0x01000193) >>> 0;
  }
  return hash >>> 0;
}

function base32Pair(hash) {
  const first = BASE32[hash % BASE32.length];
  const second = BASE32[Math.floor(hash / BASE32.length) % BASE32.length];
  return `${first}${second}`;
}

export function getItemMark(itemId, variantKey, enchantmentId) {
  const payload = [normalizePart(itemId), normalizePart(variantKey), normalizePart(enchantmentId)].join("|");
  const hash = fnv1a(payload);
  const firstIndex = hash % SIGIL_GLYPHS.length;
  const secondIndex = (hash >>> 5) % SIGIL_GLYPHS.length;
  const thirdIndex = (hash >>> 10) % SIGIL_GLYPHS.length;
  const glyphs = `${SIGIL_GLYPHS[firstIndex]}${SIGIL_GLYPHS[secondIndex]}`;
  const tooltipGlyphs = `${SIGIL_GLYPHS[firstIndex]}${SIGIL_GLYPHS[secondIndex]}${SIGIL_GLYPHS[thirdIndex]}${SIGIL_GLYPHS[(hash >>> 15) % SIGIL_GLYPHS.length]}`;
  const shortcode = `#${base32Pair(hash)}`;
  return { glyphs, tooltipGlyphs, shortcode, hash };
}

export function getItemMarkDisplay(mode, itemId, variantKey, enchantmentId) {
  const mark = getItemMark(itemId, variantKey, enchantmentId);
  return mode === "shortcode" ? mark.shortcode : mark.glyphs;
}

export function getItemMarkTooltipDisplay(mode, itemId, variantKey, enchantmentId) {
  const mark = getItemMark(itemId, variantKey, enchantmentId);
  return mode === "shortcode" ? mark.shortcode : mark.tooltipGlyphs;
}

export function resolveItemMarkDisplays(mode, entries) {
  const resolved = new Map();
  if (mode === "shortcode") {
    for (const entry of entries) {
      resolved.set(entry.key, getItemMark(entry.itemId, entry.variantKey, entry.enchantmentId).shortcode);
    }
    return resolved;
  }

  const bySigil = new Map();
  for (const entry of entries) {
    const mark = getItemMark(entry.itemId, entry.variantKey, entry.enchantmentId);
    const group = bySigil.get(mark.glyphs);
    if (group) group.push(entry);
    else bySigil.set(mark.glyphs, [entry]);
  }

  for (const groupEntries of bySigil.values()) {
    if (groupEntries.length === 1) {
      const entry = groupEntries[0];
      resolved.set(entry.key, getItemMark(entry.itemId, entry.variantKey, entry.enchantmentId).glyphs);
      continue;
    }

    const byThree = new Map();
    for (const entry of groupEntries) {
      const mark = getItemMark(entry.itemId, entry.variantKey, entry.enchantmentId);
      const three = mark.tooltipGlyphs.slice(0, 3);
      const list = byThree.get(three);
      if (list) list.push(entry);
      else byThree.set(three, [entry]);
    }

    for (const [three, entriesForThree] of byThree.entries()) {
      if (entriesForThree.length === 1) {
        resolved.set(entriesForThree[0].key, three);
        continue;
      }
      for (const entry of entriesForThree) {
        resolved.set(entry.key, getItemMark(entry.itemId, entry.variantKey, entry.enchantmentId).shortcode);
      }
    }
  }

  return resolved;
}
